import { t } from "i18next";
import { useResponsive } from "../../hooks/useResponsive";
import { useTranslationEx } from "../../hooks/useTranslationEx";
import { ProdPricing } from "./ProdPricing";

export const TicketBoxBottom = ({
  product,
}: {
  product: ProductBaseResponse;
  home?: boolean;
}) => {
  const { t2 } = useTranslationEx();
  return (
    <div className="relative flex h-full w-full flex-col items-start justify-end px-4 text-start text-white">
      <div className="flex items-center space-x-[0.375rem]">
        <p className="text-xs">{t2(product.categoryName)}</p>

        {/** just is example, it will be fix again as soon - thien*/}
        <div className="h-[0.375rem] w-[0.375rem] rounded-full bg-white"></div>
        <p className="text-sm">{t2(product.cityName)}</p>
      </div>
      <p className="mb-[0.5rem] text-sm font-semibold">{product.name}</p>
      <div className="pb-4 text-base font-normal text-white">
        {/* {t("From:")}{" "}
        <span className="text-[1.375rem] font-semibold">
          {formatMoney(product.price)}
        </span> */}
        <ProdPricing {...product} vari="WHITE" />
      </div>
    </div>
  );
};

export const ProdCardBottom: React.FC<
  ProductBaseResponse & {
    home?: boolean;
  }
> = ({ home, ...product }) => {
  const { isDesktop } = useResponsive();
  const { t2 } = useTranslationEx();
  const name = t2(product.name);
  const productName = isDesktop
    ? name
    : name.length > 30
      ? name.slice(0, 30) + "..."
      : name;
  return (
    <div className={"flex h-full w-full flex-col justify-between p-4"}>
      <div
        className="flex w-full flex-col gap-[0.3125rem]"
        style={{
          flex: "1 0 auto",
        }}
      >
        {(product.productType === "TICKET" || product.productType === "TOUR") &&
          product.categoryName && (
            <span className="flex h-[24px] w-fit items-center justify-center gap-[1px] rounded-[5px] bg-[#F7F8FA] px-[7px] py-px">
              <span className="text-[10px] leading-[18px] text-[#5E6D77] sm:text-xs">
                {t(product.categoryName)}
              </span>
            </span>
          )}

        <h6 className="my-auto flex min-h-[24px] items-center justify-start text-start text-xs font-semibold leading-[1.5rem] text-[#232323] sm:text-base">
          {productName}
        </h6>
      </div>
      <div>
        <span className="mt-auto flex h-[18px] items-center text-[11px] font-normal leading-[18px] text-[#5E6D77] sm:text-xs">
          {[product.cityName, product.countryName]
            .filter((x) => x)
            .map((x) => t2(x))
            .join(", ")}
        </span>
        <hr className="divider my-2 border-gray-200 sm:my-4" />
        <ProdPricing {...product} />
      </div>
    </div>
  );
};
// {/* Info */}
// <div className="w-full flex flex-col items-start px-5">
// <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//   {name}
// </p>

// <div className="w-full text-left">
//   <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
//   <hr className="w-full border-t border-[#DCDCDC] my-5" />
//   <p className="text-sm text-gray font-normal pb-5">
//     <span className="text-base text-[#232323] font-semibold">
//       {formatMoney(price)}{" "}
//     </span>
//     {originalPrice && (
//       <>
//         <span className="text-base text-[#232323] font-semibold">
//           {" "}
//           ~{" "}
//         </span>
//         <span className="original-price">
//           {" "}
//           {formatMoney(originalPrice)}
//         </span>
//       </>
//     )}
//   </p>
// </div>
// </div>

// {/* Info */}
// <div className="w-full flex flex-col items-start px-5">
// <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//   {name}
// </p>
// <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
// <hr className="w-full border-t border-[#DCDCDC] my-5" />
// <p className="text-sm text-gray font-normal pb-5">
//   <span className="text-base text-[#232323] font-semibold">
//     {formatMoney(price)} ~
//   </span>
//   <span className="original-price"> {formatMoney(originalPrice)}</span>
// </p>
// </div>

// {/* Info */}
// <div className="w-full flex flex-col items-start px-5">
// <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//   {name}
// </p>

// <div className="w-full text-left">
//   <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
//   <hr className="w-full border-t border-[#DCDCDC] my-5" />
//   <p className="text-sm text-gray font-normal pb-5">
//     <span className="text-base text-[#232323] font-semibold">
//       {formatMoney(price)}{" "}
//     </span>
//     {originalPrice && (
//       <>
//         <span className="text-base text-[#232323] font-semibold">
//           {" "}
//           ~{" "}
//         </span>
//         <span className="original-price">
//           {" "}
//           {formatMoney(originalPrice)}
//         </span>
//       </>
//     )}
//   </p>
// </div>
// </div>

// {/* Info */}
// <div className="w-full flex flex-col items-start px-5">
// <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//   {name}
// </p>
// <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
// <hr className="w-full border-t border-[#DCDCDC] my-5" />
// <p className="text-sm text-gray font-normal pb-5">
//   <span className="text-base text-[#232323] font-semibold">
//     {formatMoney(discountPrice)} ~
//   </span>
//   <span className="original-price"> {formatMoney(originalPrice)}</span>
// </p>
// </div>

// {/* Info */}
// <div className="w-full flex flex-col items-start px-5">
//   <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//     {name}
//   </p>
//   <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
//   <hr className="w-full border-t border-[#DCDCDC] my-5" />
//   <p className="text-sm text-gray font-normal pb-5">
//     <span className="text-base text-[#232323] font-semibold">
//       {formatMoney(discountPrice)} ~
//     </span>
//     <span className="original-price"> {formatMoney(originalPrice)}</span>
//   </p>
// </div>

// {/* Info */}
// <div className="w-full flex flex-col items-start px-5 h-full justify-between">
// <div className="flex gap-1 items-center mb-[0.375rem]">
//   <img
//     className="w-[0.875rem] h-[0.875rem]"
//     src="../../../assets/icons/location-black.svg"
//     alt=""
//   />
//   <p className="text-sm text-[#5E6D77] font-normal">{location}</p>
// </div>
// <p className="text-lg font-semibold mb-[0.3125rem] text-left text-[#232323]">
//   {name}
// </p>
// <hr className="w-full border-t border-[#DCDCDC] my-5" />
// <div className="flex justify-between w-full pb-5">
//   <p className="text-sm text-gray font-normal">
//     <span className="text-base text-[#232323] font-semibold">
//       {formatMoney(price)} ~
//     </span>
//     <span className="original-price">{formatMoney(originalPrice)}</span>
//   </p>
//   <div className="flex items-center gap-[0.3125rem]">
//     <img
//       className="w-4 h-4"
//       src="../../../assets/icons/time.svg"
//       alt=""
//     />
//     <p className="text-[0.875rem] leading-[1.375rem] text-[#5E6D77] font-normal">
//       {duration && Utils.convertDuration(duration)}
//     </p>
//   </div>
// </div>
// </div>

// <div className="ticket-info p-4">
//         <p className="category text-xs font-medium text-blue-500 uppercase">
//           {p.categoryName}
//         </p>
//         <div className="flex justify-center items-center h-[3.25rem]">
//           <p className="name text-lg font-semibold text-gray-800 mt-1 text-start">
//             {p.}
//           </p>
//         </div>

//         <p className="location text-sm text-gray-500">{location}</p>
//         <hr className="divider my-2 border-gray-200" />
//         <p className="price-info text-base font-medium text-gray-800">
//           <span className="current-price text-green-600">${startingPrice}</span>
//           {oldPrice && (
//             <>
//               <span className="separator text-gray-400 mx-1"> ~ </span>
//               <span className="old-price text-gray-400 line-through">
//                 ${oldPrice}
//               </span>
//             </>
//           )}
//         </p>
//       </div>

/* <div className="ticket-info p-4">
<p className="category text-xs font-medium text-blue-500 uppercase">
  {category}
</p>
<div className="flex justify-center items-center h-[3.25rem]">
  <p className="name text-lg font-semibold text-gray-800 mt-1 text-start">
    {name}
  </p>
</div>

<p className="location text-sm text-gray-500">{location}</p>
<hr className="divider my-2 border-gray-200" />
<p className="price-info text-base font-medium text-gray-800">
  <span className="current-price text-green-600">${startingPrice}</span>
  {oldPrice && (
    <>
      <span className="separator text-gray-400 mx-1"> ~ </span>
      <span className="old-price text-gray-400 line-through">
        ${oldPrice}
      </span>
    </>
  )}
</p>
</div> */
